import styled from "styled-components";
import {Tab, Tabs} from "./tabs";
import React from "react";

const TabContainer = ({selectedTab, children, toggleSection}) => {

    const handleChange = (e, value) => {
        toggleSection(value)
    }

    return (
        <Container>
            <TabsContainer>
                <Tabs selectedTab={selectedTab} onChange={handleChange}>
                    {children.map(child => (
                        <Tab
                            key={child.key}
                            label={child.label}
                            value={child.value}
                        />
                    ))}
                </Tabs>
            </TabsContainer>
        </Container>
    )
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
  width: 50%;
  @media (min-width: 1000px) {
    width: 100%;
  }
`

const TabsContainer = styled.div`
  display: flex;
  padding: 2px;
  gap: 1rem;
  border-radius: 20px;
  width: 100%;
  @media (min-width: 1000px) {
    width: 1000px;
  }

`


export default TabContainer